import { render, staticRenderFns } from "./Authfake.vue?vue&type=template&id=53714059&"
import script from "./Authfake.vue?vue&type=script&lang=js&"
export * from "./Authfake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports